import React from 'react';
import Logo from '../logo.png'
import "./Footer.css";
import AppStore from '../assets/appstore.svg';
import GooglePlay from '../assets/googleplay.png';
export default class Footer extends React.Component {


    constructor() {
        super();


        
    }
    render() {

        return <div style={{marginTop:0,width:"100%", backgroundColor:"#F7F8F8", paddingTop:72, paddingBottom:25, textAlign:"center", justifyContent:"center",display:"flex"}}>


            <div style={{maxWidth:1024,width:"100%", justifyContent:"space-between", display:"flex",flexDirection:"column"}}>

                <div style={{width:"100%", justifyContent:"space-between", display:"flex", flexWrap:"wrap"}}>
                <div style={{display:"flex"}} className='footerTextParent'>
                    <div style={{textAlign:"left",color:"#4A4A4A"}}>
                        <p style={{fontSize:16,fontWeight:"600", marginBottom:20}}>Genel</p>
                         {/* <p style={{marginBottom:8}}>About Us</p>
                        <p style={{marginBottom:8}}>Company Info</p>
                        <p style={{marginBottom:8}}>Newsroom</p>
                        <p style={{marginBottom:8}}>Careers</p>  */}
                        {/* <p style={{marginBottom:8}}><a href='pricing' style={{textDecoration:"none",color:"rgb(74, 74, 74)"}}>Uygulamayı İndir</a></p> */}
                        <p style={{marginBottom:8}}><a href='hakkimizda' style={{textDecoration:"none",color:"rgb(74, 74, 74)"}}>Hakkımızda</a></p>
                        <p style={{marginBottom:8}}><a href='pricing' style={{textDecoration:"none",color:"rgb(74, 74, 74)"}}>Taşımacım Fiyatlandırma</a></p>
                        <p style={{marginBottom:8}}><a href='sss' style={{textDecoration:"none",color:"rgb(74, 74, 74)"}}>Sıkça Sorulan Sorular</a></p>
                        <p  style={{marginBottom:8, textDecoration:"none"}}><a style={{textDecoration:"none",color:"rgb(74, 74, 74)"}} target="_blank" href='toplulukkurallari.pdf'>Topluluk Kuralları</a></p>
                    </div>
                    {/* <div style={{textAlign:"left",color:"#4A4A4A", marginLeft:50}}>
                        <p style={{fontSize:16,fontWeight:"600", marginBottom:20}}>Service</p>
                        <p style={{marginBottom:8}}>TaşıVan</p>
                        <p style={{marginBottom:8}}>TaşıDelivery</p>
                        <p style={{marginBottom:8}}>TaşıBusiness</p>
                        <p style={{marginBottom:8}}>Moving</p>
                        <p style={{marginBottom:8}}>TaşıEnergy</p>
                    </div> */}

                    <div className='footerLong' style={{textAlign:"left",color:"#4A4A4A", marginLeft:70}}>
                        <p style={{fontSize:16,fontWeight:"600", marginBottom:20}}>Destek</p>
                        
                        {/* <p style={{marginBottom:8}}>Cargo Compensation Promises</p> */}
                        {/* <p style={{marginBottom:8}}>Yardım Merkezi</p> */}
                        <p  style={{marginBottom:8, textDecoration:"none"}}><a style={{textDecoration:"none",color:"rgb(74, 74, 74)"}} href='kullanicisozlesmesi'>Şartlar ve Koşullar</a></p>
                        <p  style={{marginBottom:8, textDecoration:"none"}}><a style={{textDecoration:"none",color:"rgb(74, 74, 74)"}} target="_blank" href='gizlilikpolitikasi.pdf'>Gizlilik Politikası</a></p>
                        <p  style={{marginBottom:8, textDecoration:"none"}}><a style={{textDecoration:"none",color:"rgb(74, 74, 74)"}} target="_blank" href='cerezpolitikasi.pdf'>Çerez Politikası</a></p>
                        <p  style={{marginBottom:8, textDecoration:"none"}}><a style={{textDecoration:"none",color:"rgb(74, 74, 74)"}} target="_blank" href='kvkkaydinlatmametni.pdf'>KVKK Aydınlatma Metni</a></p>
                        <p  style={{marginBottom:8, textDecoration:"none"}}><a style={{textDecoration:"none",color:"rgb(74, 74, 74)"}} target="_blank" href='elektronikiletiaydinlatmametni.pdf'>E.I. Aydınlatma Metni</a></p>
                    </div>
                </div>

                <div className='footerLogo'>
                    <div>
                    <img src={Logo} style={{height:30}}  /></div>

                    <div style={{display:"flex",justifyContent:"flex-end",marginTop:16}}>
                        <a href='https://apps.apple.com/us/app/ta%C5%9F%C4%B1mac%C4%B1m-h%C4%B1zl%C4%B1-teslimat/id1628858483' target={"_blank"}>
                            <img style={{height:45}} src={AppStore} />
                        </a>

                        <a href='https://play.google.com/store/apps/details?id=com.tasimacim.tasimacim' target={"_blank"}>
                            <img style={{height:45, marginLeft:10}} src={GooglePlay} />
                        </a>
                    </div>
                </div>
                </div>

                

                <div style={{borderTopWidth:1, borderTopStyle:"solid", borderTopColor:"#4A4A4A", marginTop:30}}>
                    <p style={{marginTop:8, marginBottom:10,color:"#4A4A4A"}}>© 2022 Taşımacım. All rights reserved.</p>
                </div>
            </div>
            
        </div>
    }
}


